import { useContext, useCallback } from 'react';

import { ALERT_EVENTS } from '../constants/actionTypes';
import { AlertContext } from '../contexts/alertContext';

const useAlert = () => {
  const [alertStates, alertDispatch] = useContext(AlertContext);

  const alert = useCallback(
    async (payload) => {
      if (payload?.message) alertDispatch({ type: ALERT_EVENTS.SET, payload });
      else alertDispatch({ type: ALERT_EVENTS.RESET });
    },
    [alertDispatch],
  );

  return {
    alert,
    alertStates,
  };
};

export default useAlert;
